var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text elevation-0",attrs:{"loading":_vm.loadingBtn,"color":"blue"},on:{"click":_vm.createNewProduct}},[_vm._v(" CREATE PRODUCT ")])}
var staticRenderFns = []

export { render, staticRenderFns }